/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import { useQuery } from 'react-query';
import { platform } from 'network-utils';

const homepageApi = platform.learningPanel.HomepageAPIs;

export const getUserAchievements = 'get-user-achievements';

export const useGetUserAchievements: any = (userUuid: string, enableQuery = true) => {
    return useQuery([getUserAchievements, userUuid], () => homepageApi.getUserAchievements(), {
        enabled: !!userUuid && enableQuery,
        staleTime: Infinity
    });
};
